// SmartTrialModal.js
import React from "react";
import "./SmartTrialModal.css";
import images from "../../../../utilities/images/images";

const SmartTrialModal = ({
  isOpen,
  onClose,
  popupTitle,
  popupDescription,
  popupBenefits,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="smart-modal-content">
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>
        <div className="checkmark-icon">
          <img src={images.DoneTick} alt="Checkmark" />
        </div>

        <div className="title">{popupTitle}</div>
        <p className="description">{popupDescription}</p>

        <div className="benefits-section">
          <h4>Your benefits</h4>
          <ul>
            {(popupBenefits || []).map((benefit, index) => (
              <li key={index}>{benefit}</li>
            ))}
          </ul>
        </div>

        <button className="start-btn" onClick={onClose}>Start Learning Now</button>
      </div>
    </div>
  );
};

export default SmartTrialModal;
